import { observable, makeObservable, action } from 'mobx'; // eslint-disable-line

class Reply {
    constructor (data, parent) {
        this.data = data;
        this.id = this.data.id;
        this.content = this.data.content;
        this.preview = this.content.length > 180 ? `${this.content.replace(/^(.{180}[^\s]*).*/, '$1')}...` : this.content;
        this.published = moment(this.data.pub_date).fromNow();
        this.author = `${this.data.owner.first_name} ${this.data.owner.last_name}`;
        this.owner = this.data.owner;

        this.parent = parent;
    };
}

class Comment {
    expanded = false;
    replies = [];

    constructor (data) {
        makeObservable(this, {
            expanded: observable,
            replies: observable,
            toggleExpand: action
        });

        this.data = data;
        this.id = this.data.id;
        this.resolved = this.data.resolved;
        this.content = this.data.content;
        this.preview = this.content.length > 180 ? `${this.content.replace(/^(.{180}[^\s]*).*/, '$1')}...` : this.content;
        this.published = moment(this.data.pub_date).fromNow();
        this.author = `${this.data.owner.first_name} ${this.data.owner.last_name}`;
        this.owner = this.data.owner;
        this.expanded = this.data.expanded || false;
        this.resource = this.data.resource || {};

        this.replies = this.data.replies.map(reply => new Reply(reply, this));
    }

    toggleExpand = () => {
        this.expanded = !this.expanded;
    }

    toRaw = () => {
        return {
            expanded: this.expanded,
            content: this.data.content,
            id: this.id,
            owner: this.data.owner,
            pub_date: this.data.pub_date,
            replies: this.replies.map(r => r.data),
            resolved: this.data.resolved,
            resource: this.data.resource || {}
        };
    }
}

export {
    Comment,
    Reply
};
